import React, { useState, useRef } from 'react';
import Button, {
  ButtonStyles,
  ButtonSizes,
  ButtonWidths,
} from '../Button/Button';
import Icon from '@iconify/react';
import iconChevronUp from '@iconify-icons/mdi/chevron-up';
import iconChevronDown from '@iconify-icons/mdi/chevron-down';

const ShowMore = ({
  itemsToDisplay,
  startingDisplayCount,
  incrementDisplayCountBy,
  showMoreButtonLabel,
  showLessButtonLabel,
  buttonStyle,
  buttonSize,
  ButtonWidth,
}) => {
  const section = useRef(null);
  const [displayedItems, setDisplayedItems] = useState(
    itemsToDisplay.slice(0, startingDisplayCount)
  );
  const addToDisplay = () =>
    setDisplayedItems(
      itemsToDisplay.slice(0, displayedItems.length + incrementDisplayCountBy)
    );
  const resetDisplay = (event) => {
    setDisplayedItems(itemsToDisplay.slice(0, startingDisplayCount));
    section.current.scrollIntoView({ behavior: 'smooth' });
  };

  const moreButton = (
    <Button
      isShowMore={true}
      style={buttonStyle}
      size={buttonSize}
      width={ButtonWidth}
      label={showMoreButtonLabel}
      onClick={addToDisplay}
      iconRight={<Icon icon={iconChevronDown} className="icon" />}
    />
  );

  const lessButton = (
    <Button
      style={buttonStyle}
      size={buttonSize}
      width={ButtonWidth}
      label={showLessButtonLabel}
      iconRight={<Icon icon={iconChevronUp} className="icon" />}
      onClick={resetDisplay}
    />
  );

  const renderControlButton = itemsToDisplay.length > startingDisplayCount;
  const buttonToShow =
    displayedItems.length < itemsToDisplay.length ? moreButton : lessButton;

  return (
    <div ref={section} className="show-more">
      <div className="show-more__grid">{displayedItems}</div>
      <div className="show-more__button">
        {renderControlButton && buttonToShow}
      </div>
    </div>
  );
};

ShowMore.propTypes = {};
ShowMore.defaultProps = {
  itemsToDisplay: [],
  startingDisplayCount: 6,
  incrementDisplayCountBy: 6,
  showMoreButtonLabel: app_main_wpml.show_more,
  showLessButtonLabel: app_main_wpml.show_less,
  buttonStyle: ButtonStyles.empty,
  buttonSize: ButtonSizes.s,
  ButtonWidth: ButtonWidths.isFull,
};

export default ShowMore;
